

type UploadDocumentNoticeProps = {
    text: string
    };

export default function UploadDocumentNotice({text}: UploadDocumentNoticeProps) { 
    return(
        <p className='bg-menthe-75 blanc p-xs grid-flex va-center jc-start fz-sm' style={{flexWrap: "nowrap"}}>
        <i className='icon-attention blanc'></i>
            {text}
        </p> 
    )
}